import { connect } from "react-redux";
import {
  Button,
  UncontrolledAlert,
  Col,
  Row,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody
} from "reactstrap";
import { withTranslation } from "react-i18next";
import React, {
  useState,
  useEffect,
} from "react";
import { AvForm, AvField } from "availity-reactstrap-validation";
import SearchableAgentDropdown from "components/Common/SearchableAgentDropdown";
import ClientDropDown from "components/Common/Filters/ClientDropDown";
import { toReportDateTimeString } from "common/utils/toReportDateTimeString";

function CashbackAdvancedFilter(props) {
  const [openCanvas, setOpenCanvas] = useState(false);

  const initValues = {
    clientId: "",
    dateFrom: "",
    dateTo: "",
    agent: "",
  };

  const { filteredValues = initValues } = props;
  const [values, setValues] = useState(filteredValues);

  const [filtered, setFilter] = useState(false);
  useEffect(() => {
    let f = JSON.stringify(initValues) === JSON.stringify(values);
    setFilter(!f);
  }, [values]);


  const clientChangeHandler = (obj) => {
    setValues({
      ...values,
      clientId: obj.value
    });
    // props.setSelectedValues(prev => ({ 
    //   ...prev, 
    //   clientId: obj.value 
    // }));
  };

  const resetFilter = () => {
    setValues(initValues);
    props.filterChangeHandler(initValues);
    props.setSelectedValues(initValues);
  };


  const toggleCanvas = () => {
    setOpenCanvas(!openCanvas);
  };

  useEffect(() => {
    if (!props.showAddSuccessMessage && openCanvas) {
      setOpenCanvas(false);
    }
  }, [props.showAddSuccessMessage]);

  return (
    <React.Fragment >
      <Button
        color="primary"
        className={"btn btn-primary"}
        onClick={toggleCanvas}>
        <i className="bx bx-filter me-1" />
        {props.t("Advance Filter")}
      </Button>
      <Offcanvas
        isOpen={openCanvas}
        direction="end"
        scrollable
        toggle={toggleCanvas}
      >
        <OffcanvasHeader toggle={toggleCanvas}
          tag="h4">
          {props.t("Advance Filter")}
        </OffcanvasHeader>
        <OffcanvasBody>
          <AvForm
            className='p-4'
            onValidSubmit={(e, v) => {
              props.filterChangeHandler(values);
              props.setSelectedValues(prev => ({ 
                ...prev, 
                ...values
              }));
              setOpenCanvas(false);
            }}
          >
            <Row>

              <Col md="12">
                <div className="mb-3">
                  <ClientDropDown
                    unlimitedClients
                    defaultValue={props?.filteredValues?.clientId || values?.clientId}
                    clientChangeHandler={clientChangeHandler}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <div className="mb-3">
                  <SearchableAgentDropdown
                    isRequired={false}
                    value={props.filteredValues?.agent || values.agent}
                    isMulti={true}
                    onChange={(e) => {
                      setValues({
                        ...values,
                        agent: e.map((item) => item.value).join(","),
                      });
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row >
              <Col xs={12} md={6}>
                <AvField
                  name="dateFrom"
                  label={props.t("Date From")}
                  type="datetime-local"
                  errorMessage={props.t("Select date From")}
                  onChange={(e) => {
                    setValues({
                      ...values,
                      dateFrom: toReportDateTimeString(e.target.value),
                    });
                  }}
                />
              </Col>
              <Col xs={12} md={6}>
                <AvField
                  name="dateTo"
                  label={props.t("Date To")}
                  type="datetime-local"
                  errorMessage={props.t("Select date To")}
                  onChange={(e) => {
                    setValues({
                      ...values,
                      dateTo: toReportDateTimeString(e.target.value),
                    });
                  }}
                />
              </Col>
            </Row>        
           
            <div className="row">
              <div className="col-sm-12 text-center">
                <Button disabled={!filtered} type="submit" color="primary" className="btn btn-primary btn-md center-block">
                  {props.t("Filter")}
                </Button>
                {" "}
                {" "}
                <Button onClick={resetFilter} color="primary" type="reset" className="btn btn-danger btn-md center-block">
                  {props.t("Reset")}
                </Button>
              </div>
            </div>

          </AvForm>
          {props.error && <UncontrolledAlert color="danger">
            <i className="mdi mdi-block-helper me-2"></i>
            {props.t(props.error)}
          </UncontrolledAlert>}
        </OffcanvasBody>
      </Offcanvas>
    </React.Fragment>
  );
}
export default (withTranslation()(CashbackAdvancedFilter));